import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { PageResponse } from '../../_shared/types/shared';
import type { UpstreamRow, UpstreamFormValues, UpstreamFilters } from '../types/upstream';

export const upstreamsApi = {
  list: async (params: UpstreamFilters & { page: number; size: number; sort?: string }) => {
    const response = await gatewayApiClient.get<PageResponse<UpstreamRow>>('/admin/upstreams', { params });
    return response.data;
  },

  get: async (id: number) => {
    const response = await gatewayApiClient.get<UpstreamRow>(`/admin/upstreams/${id}`);
    return response.data;
  },

  create: async (body: UpstreamFormValues) => {
    const response = await gatewayApiClient.post<UpstreamRow>('/admin/upstreams', body);
    return response.data;
  },

  replace: async (id: number, body: UpstreamFormValues) => {
    const response = await gatewayApiClient.put<UpstreamRow>(`/admin/upstreams/${id}`, body);
    return response.data;
  },

  delete: async (id: number) => {
    await gatewayApiClient.delete(`/admin/upstreams/${id}`);
  },
};
